import React, { useState, useEffect, useCallback } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../components/ui/dialog';
import { ScrollArea } from '../components/ui/scroll-area';
import { Badge } from '../components/ui/badge';
import { Pin } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PinnedMessagesPanel = ({ open, onClose, channelId }) => {
  const [pins, setPins] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPins = useCallback(async () => {
    if (!channelId) return;
    setLoading(true);
    try {
      const res = await axios.get(`${API}/channels/${channelId}/pins`);
      setPins(res.data.pins);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, [channelId]);

  useEffect(() => {
    if (open) fetchPins();
  }, [open, fetchPins]);

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-md" data-testid="pinned-messages-dialog">
        <DialogHeader>
          <DialogTitle style={{fontFamily: 'Space Grotesk'}} className="flex items-center gap-2">
            <Pin className="w-5 h-5" /> Pinned Messages
          </DialogTitle>
          <DialogDescription>{pins.length} pinned message{pins.length !== 1 ? 's' : ''}</DialogDescription>
        </DialogHeader>
        <ScrollArea className="max-h-[400px]">
          {loading ? (
            <div className="py-8 text-center">
              <div className="w-6 h-6 border-2 border-[hsl(var(--primary))] border-t-transparent rounded-full animate-spin mx-auto" />
            </div>
          ) : pins.length === 0 ? (
            <div className="py-8 text-center">
              <Pin className="w-10 h-10 mx-auto text-muted-foreground/30 mb-3" />
              <p className="text-sm text-muted-foreground">No pinned messages yet</p>
            </div>
          ) : (
            <div className="space-y-2">
              {pins.map(msg => (
                <div key={msg.message_id} className="p-3 rounded-lg bg-[hsl(var(--surface-2))] border border-border" data-testid={`pinned-msg-${msg.message_id}`}>
                  <div className="flex items-center gap-2 mb-1">
                    <div className="w-5 h-5 rounded-full bg-[hsl(var(--primary)/0.15)] flex items-center justify-center text-[10px] font-bold text-[hsl(var(--primary))]">
                      {msg.sender_name?.[0] || '?'}
                    </div>
                    <span className="text-xs font-medium">{msg.sender_name}</span>
                    <span className="text-xs text-muted-foreground">
                      {new Date(msg.timestamp).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}
                    </span>
                  </div>
                  <p className="text-sm">{msg.content}</p>
                </div>
              ))}
            </div>
          )}
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default PinnedMessagesPanel;